export default [
  {label: 'Oferta ', path: {name: 'static-offer'}},
  {label: 'Kalkulator leasingowy ', path: {name: 'kalkulator-leasingowy'}},
  {label: 'O nas ', path: {name: 'static-about'}},
  {label: 'Relacje inwestorskie ', path: {name: 'static-information'}},
  {label: 'Obsługa klienta ', path: {name: 'static-customer-service'}},
  {label: 'Kontakt ', path: {name: 'static-contact'}},
]
